<template>
  <!-- 报名活动 -->
  <div>
    <Form ref="form" :model="formData" :label-width="100" class="page-form">
      <FormItem prop="type" label="活动类型" :rules="$units.formRule.required('请选择')" class="full" label-position="left">
        <RadioGroup v-model="formData.type" @on-change="changeType">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">增员活动（直接推荐人）</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">出单活动（业务员）</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'">签约活动</Radio>
          <Radio label="4" :disabled="formData.status == '1' || formData.status == '-1'" v-if="$units.isOkBao()">报名活动</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import _ from 'lodash';
export default {
  props: ['tableList', 'activityType', 'id', 'compontntType'],
  mixins: [pageTool],
  data() {
    return {
      formData: {
        type: '4',
        mode: '2',
        rewardType: [],
        calFactor: '2',
        productType: '1',
        conditionalIndicator: '2',
        needSignup: '0',
        calculateType: '0'
      },
    };
  },
  methods: {
    // 修改活动类型
    changeType(value) {
      const formData = JSON.parse(JSON.stringify(this.formData));
      if (formData.type == 1) {
        formData.rewardType = '1';
      } else if(formData.type == 2) {
        formData.mode = '1';
        formData.rewardType = [];
      } else if(formData.type == 3) {
        formData.mode = '2';
        formData.rewardType = [];
      }
      this.$emit('typeChange', formData);
      this.$bus.$emit('resetList', formData);
    },
    // 回显信息
    setData(data) {
      this.formData = {
        status: data.status,
        type: String(data.type),
      };
    },
  },
  watch: {
    activityType(newVal) {
      this.formData.type = newVal;
    }
  }
};
</script>
<style lang="scss" scoped>
.tip {
  display: flex;
  align-items: center;
  height: 40px;
  height: 40px;
  padding-left: 20px;
  background: #f7faff;
  border-radius: 4px;
  .title {
    font-weight: bold;
  }
  p {
    color: #3f6ec9;
    font-size: 12px;
  }
}
.btn-item {
  margin-bottom: 30px;
  display: flex;
}
/deep/ .ivu-radio-group-item {
  margin-right: 20px !important;
}
/deep/ .ivu-checkbox-group-item {
  margin-right: 20px !important;
}
</style>
